// Bangla translations
const bn = {
  // Navigation
  nav: {
    guides: 'তথ্য ভান্ডার',
    services: 'সেবা সংযোগ',
    faq: 'প্রশ্নোত্তর',
    contact: 'যোগাযোগ',
    about: 'আমাদের সম্পর্কে',
    help: 'সাহায্য নিন',
    adminLogin: 'Admin Login',
  },
  
  // Landing Page
  landing: {
    badge: 'বাংলাদেশের প্রথম ভূমি তথ্য প্ল্যাটফর্ম',
    heroTitle1: 'ভূমির সব সমস্যা',
    heroTitle2: 'এক জায়গায়',
    heroSubtitle: 'নামজারি, খতিয়ান, দলিল থেকে শুরু করে যাচাইকৃত উকিল ও এজেন্ট - জমি সংক্রান্ত সব তথ্য ও সেবা এখন আপনার হাতের মুঠোয়।',
    ctaStart: 'এখনই শুরু করুন',
    ctaLearnMore: 'আরও জানুন',
    emailPlaceholder: 'আপনার ইমেইল দিন',
    subscribe: 'সাবস্ক্রাইব',
    whyChoose: 'কেন',
    whyChooseUs: 'বেছে নেবেন?',
    whyChooseDesc: 'আমরা জমি সংক্রান্ত সকল সমস্যার সহজ সমাধান দিতে প্রতিশ্রুতিবদ্ধ',
    popularGuides: 'জনপ্রিয় গাইড',
    popularGuidesDesc: 'সবচেয়ে বেশি পড়া তথ্য গাইডগুলো',
    viewAll: 'সব দেখুন',
    readMore: 'বিস্তারিত পড়ুন',
    haveProblem: 'জমি নিয়ে সমস্যায় আছেন?',
    connectProviders: 'আমাদের যাচাইকৃত সেবাদাতাদের সাথে যোগাযোগ করুন',
    findProviders: 'সেবাদাতা খুঁজুন',
  },
  
  // Features
  features: {
    completeInfo: 'সম্পূর্ণ তথ্য',
    completeInfoDesc: 'নামজারি, খতিয়ান, রেজিস্ট্রেশন সহ সকল ভূমি সংক্রান্ত তথ্য এক জায়গায়।',
    verifiedProviders: 'যাচাইকৃত সেবাদাতা',
    verifiedProvidersDesc: 'অভিজ্ঞ উকিল, এজেন্ট ও ডকুমেন্ট সহকারীদের সাথে সরাসরি যোগাযোগ।',
    trustedPlatform: 'বিশ্বস্ত প্ল্যাটফর্ম',
    trustedPlatformDesc: 'সঠিক তথ্য ও নির্ভরযোগ্য সেবা নিশ্চিত করতে প্রতিশ্রুতিবদ্ধ।',
  },
  
  // Stats
  stats: {
    guides: 'তথ্য গাইড',
    providers: 'যাচাইকৃত সেবাদাতা',
    users: 'সন্তুষ্ট ব্যবহারকারী',
  },
  
  // Categories
  categories: {
    all: 'সব',
    documentation: 'ডকুমেন্টেশন',
    legal: 'আইনি',
    fees: 'ফি ও খরচ',
    lawyer: 'উকিল',
    agent: 'এজেন্ট',
    documentAssistant: 'ডকুমেন্ট সহকারী',
  },
  
  // Information Hub
  hub: {
    title: 'তথ্য ভান্ডার',
    subtitle: 'জমি সংক্রান্ত সকল গুরুত্বপূর্ণ তথ্য, প্রক্রিয়া ও গাইডলাইন এক জায়গায়।',
    searchPlaceholder: 'গাইড খুঁজুন...',
    noResults: 'কোনো গাইড পাওয়া যায়নি',
    tryAnother: 'অন্য কীওয়ার্ড দিয়ে খুঁজুন',
  },
  
  // Guide Detail
  guide: {
    backToHub: 'তথ্য ভান্ডারে ফিরুন',
    steps: 'ধাপসমূহ',
    tips: 'গুরুত্বপূর্ণ টিপস',
    warning: 'সতর্কতা',
    downloadPdf: 'PDF ডাউনলোড',
    needHelp: 'সাহায্য দরকার?',
    helpDesc: 'আমাদের যাচাইকৃত সেবাদাতারা আপনাকে সাহায্য করতে প্রস্তুত',
    notFound: 'গাইড পাওয়া যায়নি',
  },
  
  // Services
  services: {
    title: 'সেবা সংযোগ',
    subtitle: 'যাচাইকৃত উকিল, এজেন্ট ও ডকুমেন্ট সহকারীদের সাথে সরাসরি যোগাযোগ করুন।',
    searchPlaceholder: 'নাম বা অবস্থান দিয়ে খুঁজুন...',
    noResults: 'কোনো সেবাদাতা পাওয়া যায়নি',
    details: 'বিস্তারিত',
    verified: 'যাচাইকৃত',
    unverified: 'অযাচাইকৃত',
    feeRange: 'ফি',
    backToList: 'সেবা তালিকায় ফিরুন',
    whatsappMessage: 'WhatsApp এ মেসেজ করুন',
    areYouProvider: 'আপনি কি একজন সেবাদাতা?',
    joinPlatform: 'ভূমি প্ল্যাটফর্মে যুক্ত হয়ে হাজারো গ্রাহকের কাছে পৌঁছান',
    apply: 'আবেদন করুন',
  },
  
  // Contact
  contact: {
    title: 'যোগাযোগ করুন',
    subtitle: 'জমি সংক্রান্ত যেকোনো প্রশ্ন বা সমস্যায় আমাদের সাথে যোগাযোগ করুন। আমরা সাহায্য করতে প্রস্তুত।',
    sendMessage: 'বার্তা পাঠান',
    contactInfo: 'যোগাযোগ তথ্য',
    name: 'নাম',
    email: 'ইমেইল',
    phone: 'ফোন',
    message: 'বার্তা',
    address: 'ঠিকানা',
    officeHours: 'অফিস সময়',
    sending: 'পাঠানো হচ্ছে...',
    send: 'বার্তা পাঠান',
  },
  
  // FAQ
  faq: {
    title: 'প্রশ্নোত্তর',
    subtitle: 'জমি সংক্রান্ত সাধারণ প্রশ্ন ও ভুল ধারণার উত্তর পান',
    stillHaveQuestions: 'এখনও প্রশ্ন আছে?',
    contactUs: 'আমাদের সাথে যোগাযোগ করুন অথবা যাচাইকৃত সেবাদাতার সাথে কথা বলুন',
  },
  
  // About
  about: {
    title: 'আমাদের',
    story: 'গল্প',
    mission: 'আমাদের লক্ষ্য',
    values: 'আমাদের মূল্যবোধ',
    valuesDesc: 'যে নীতিগুলো আমাদের পথ দেখায়',
    whatWeOffer: 'আমরা কী অফার করি',
    joinUs: 'আমাদের সাথে যুক্ত হন',
    joinUsDesc: 'জমি সংক্রান্ত যেকোনো সমস্যায় আমরা আপনার পাশে আছি',
  },
  
  // Privacy
  privacy: {
    title: 'গোপনীয়তা নীতি ও শর্তাবলী',
    lastUpdated: 'সর্বশেষ আপডেট',
    importantNotice: 'গুরুত্বপূর্ণ বিজ্ঞপ্তি',
    privacyPolicy: 'গোপনীয়তা নীতি',
    termsOfService: 'সেবার শর্তাবলী',
    haveQuestions: 'প্রশ্ন আছে?',
  },
  
  // Ratings
  ratings: {
    title: 'রিভিউ ও রেটিং',
    writeReview: 'রিভিউ লিখুন',
    noReviews: 'এখনও কোনো রিভিউ নেই',
    beFirst: 'প্রথম রিভিউ দিন',
    rating: 'রেটিং',
    review: 'রিভিউ',
    submit: 'জমা দিন',
    reviewerName: 'আপনার নাম',
  },
  
  // Footer
  footer: {
    disclaimer: 'কোনো জমি কেনা-বেচা বা আইনি নিশ্চয়তা প্রদান করে না। আমরা তথ্য ও সংযোগের একটি প্ল্যাটফর্ম।',
    important: 'গুরুত্বপূর্ণ',
    info: 'তথ্য',
    service: 'সেবা',
    organization: 'প্রতিষ্ঠান',
    rights: 'সর্বস্বত্ব সংরক্ষিত।',
  },
  
  // Admin
  admin: {
    dashboard: 'ড্যাশবোর্ড',
    guides: 'গাইড',
    services: 'সেবাদাতা',
    leads: 'লিড',
    settings: 'সেটিংস',
    users: 'ব্যবহারকারী',
    logout: 'লগআউট',
    login: 'লগইন',
    register: 'রেজিস্ট্রেশন',
    password: 'পাসওয়ার্ড',
    save: 'সেভ করুন',
    saving: 'সেভ হচ্ছে...',
    create: 'তৈরি করুন',
    update: 'আপডেট করুন',
    delete: 'মুছুন',
    edit: 'সম্পাদনা',
    add: 'যোগ করুন',
    new: 'নতুন',
    total: 'মোট',
  },
  
  // Common
  common: {
    loading: 'লোড হচ্ছে...',
    error: 'কিছু সমস্যা হয়েছে',
    success: 'সফল হয়েছে',
    cancel: 'বাতিল',
    confirm: 'নিশ্চিত',
    yes: 'হ্যাঁ',
    no: 'না',
    back: 'ফিরুন',
    next: 'পরবর্তী',
    previous: 'পূর্ববর্তী',
    search: 'খুঁজুন',
    filter: 'ফিল্টার',
    sort: 'সাজান',
    more: 'আরও',
    less: 'কম',
  },
  
  // Install Prompt
  install: {
    title: 'App ইনস্টল করুন',
    description: 'Home screen এ যোগ করুন দ্রুত অ্যাক্সেসের জন্য',
    button: 'ইনস্টল করুন',
    iosTitle: 'iOS এ ইনস্টল করুন',
    iosStep1: 'নিচে Share বাটনে ক্লিক করুন',
    iosStep2: '"Add to Home Screen" অপশনে ক্লিক করুন',
    iosStep3: '"Add" বাটনে ক্লিক করুন',
    understood: 'বুঝেছি',
  },
};

export default bn;
